export const GET_ACTIONTYPE_REQUEST = 'GET_ACTIONTYPE_REQUEST';
export const GET_ACTIONTYPE_SUCCESS = 'GET_ACTIONTYPE_SUCCESS';
export const GET_ACTIONTYPE_FAILURE = 'GET_ACTIONTYPE_FAILURE';
